
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: {
    ResponsiveDialog
  },
  props: {
    dialog: false,
    category: {
      defaault: () => {},
      type: Object
    }
  },
  methods: {
    handleAddSubCategory() {
      this.$emit("add-sub-category", this.category);
    }
  }
};
